import { GET_TREATMENT_GROUP_MEMBERSHIPS_BY_PERSON_QUERY_KEY } from '@/constants/treatmentGroups';
import useAPI from '@/hooks/useAPI';
import useDebouncedValue from '@/hooks/useDebouncedValue';
import TreatmentGroupRepository from '@/repositories/TreatmentGroupRepository';
import { TreatmentGroupMembershipByPerson } from '@/types/treatmentGroup';

// Informational only, badges a person who's already enrolled in a different
// group -- disabled with no person id since there's nothing to check yet.
const useOtherGroupMembership = (personId: string | null, excludeGroupId?: string) => {
  const treatmentGroupRepository = TreatmentGroupRepository();
  const debounced = useDebouncedValue({ personId, excludeGroupId });

  return useAPI<TreatmentGroupMembershipByPerson[]>({
    enabled: !!debounced.personId,
    queryKey: [GET_TREATMENT_GROUP_MEMBERSHIPS_BY_PERSON_QUERY_KEY, debounced],
    queryFn: () =>
      treatmentGroupRepository.getMembershipsByPerson(
        debounced.personId as string,
        debounced.excludeGroupId
      ),
    supressErrorMessages: true
  });
};

export default useOtherGroupMembership;
